
import { IEntityMapping } from '@/typings/import';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Passenger from '@/components/Passenger/models/Passenger';
import MappingPropertyInput from '@/components/Importer/MappingPropertyInput.vue';

@Component({
  components: {
    MappingPropertyInput,
  },
})
export default class PassengerSearchMapper extends Vue {
  mapping: IEntityMapping<Passenger> | null = null;
  showMappings: boolean = true;

  @Prop({ required: true }) value: IEntityMapping<Passenger>;

  @Watch('value', { immediate: true }) onValueChanged() {
    this.mapping = this.value;
  }

  @Watch('mapping', { deep: true, immediate: true }) onMappingChanged() {
    this.$emit('input', this.mapping);
  }
}
